import { toast } from "../../components/ui/use-toast";
import axios from "axios";
import { CircleCheckBig } from "lucide-react";
import { z } from "zod";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllJobs = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseUrl}/api/recruitment`, config);
    return { jobs: response.data.jobs };
  } catch (error) {
    console.error(error);
  }
};

export const deleteJob = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(
      `${baseUrl}/api/recruitment/${id}`,
      config
    );
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateJob = async (
  formData: any,
  setFormData: Function,
  RecruitmentCreateSchema: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    RecruitmentCreateSchema.parse(formData);
    const response = await axios.post(`${baseUrl}/api/recruitment/`, formData, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/recrutement");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const fetchAllJobs = async (page: number) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/recruitment/all?page=${page}`
    );
    return {
      data: response.data.jobs,
      totalPages: response.data.totalPages,
      totalCount: response.data.totalCount,
    };
  } catch (error) {
    console.error(error);
  }
};
